export default {"src":"/_next/static/media/fsm-wordmark-black.d7d99995.svg","height":92,"width":500,"blurWidth":0,"blurHeight":0};